import { render, staticRenderFns } from "./DialogDefenderDados.vue?vue&type=template&id=56218085&scoped=true&"
import script from "./DialogDefenderDados.vue?vue&type=script&lang=js&"
export * from "./DialogDefenderDados.vue?vue&type=script&lang=js&"
import style0 from "./DialogDefenderDados.vue?vue&type=style&index=0&id=56218085&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56218085",
  null
  
)

export default component.exports